var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.score)?_c('div',[(_vm.isProcessGroup)?_c('ScoreboardWithPoint',{attrs:{"scoreGroup":_vm.score}}):_c('div',{staticClass:"b-portlet"},[_c('div',{staticClass:"b-portlet-body"},[_c('Scoreboard',{attrs:{"data":_vm.score,"textReportActive":_vm.textReportActive},on:{"showTextReport":_vm.showTextReport}})],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }